import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import { TypeAsserter } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import * as reportsGql from '../../gql'
import type { Context } from '../../types'

import * as gql from './gql'

/** API for requesting a space report be generated as a file */
@ngCore.Injectable()
export class Api {
  /**
   * Requests the given report be generated as a file in the background. The
   * result becomes available on the process this starts — see the processes
   * slideout
   */
  public generate(
    context: Context,
    { configuration, id }: Api.Generate.Params,
  ): rxjs.Observable<void> {
    TypeAsserter.assertIsNotNullish(context)
    return gql.mutations.generateSpaceReportFile.executor({
      ...context,
      configuration: reportsGql.inputs.configuration.getGqlFrom(
        id,
        configuration,
      ),
      reportId: TypeAsserter.validate(
        reportsGql.enums.reportId.TRANSFORMER.getGqlFrom(id),
        TypeAsserter.assertIsNotNullish,
      ),
    })
  }
}

export namespace Api {
  export namespace Generate {
    export interface Params {
      readonly configuration: ents.extra.space.Report.Configuration
      readonly id: ents.extra.space.Report.Id
    }
  }
}
